import { DeliveryProviderType } from "clearline-api";
import { Platform } from "./platform";
import { PlatformAccountBase } from "./platform-account-base";
import { PlatformAccountStatus } from "./platform-provisioning";

export class PlatformAccount extends PlatformAccountBase {
  id: number;
  username: string;
  password: string;
  userId?: number;
  platformId: number;
  platformAccountId?: string;
  platform?: Platform;
}
export class UserPlatformAccount extends PlatformAccount {
  status: PlatformAccountStatus;
  errorMessage?: string | null;
}
export class DeliveryPlatformAccount extends PlatformAccount {
  public deliveryProviderPlatformId: DeliveryProviderType;
}
